import React from 'react'
import Counter from '../component/Counter'
import SecondaryBtn from '../component/btn/SecondaryBtn'
import pxImg01 from '../images/px-img-07.png'
import Tabs from '../component/Tabs'
import { Helmet } from 'react-helmet'
import MainTestimonial from "../component/slider/MainTestimonial" 
import Blog from '../component/Blog'
import Cta from '../component/Cta'
import logo25 from '../images/courier/courier-logo25.png'
import logo26 from '../images/courier/courier-logo26.png'
import logo27 from '../images/courier/courier-logo27.png'
import logo28 from '../images/courier/courier-logo28.png'
import logo29 from '../images/courier/courier-logo29.png'
import logo30 from '../images/courier/courier-logo30.png'
import logo31 from '../images/courier/courier-logo31.png'
import logo32 from '../images/courier/courier-logo32.png'
import logo33 from '../images/courier/courier-logo33.png'
import logo34 from '../images/courier/courier-logo34.png'
import logo35 from '../images/courier/courier-logo35.png'
export default function ChannelIntegration() {
    const tabsData = [
            {
                title: "All",
                items: [
                    { img: logo25, text: "Seamlessly sync and manage your Amazon orders with automated shipping and tracking. Process orders faster with real-time updates and centralized logistics management" },
                    { img: logo26, text: "Integrate your Shopify store to automate order imports, shipping, and tracking updates. Simplify fulfillment with real-time sync and multi-courier shipping options." },
                    { img: logo27, text: "Connect your WooCommerce store to manage orders and shipments from a single dashboard. Automate shipping workflows and provide real-time tracking to customers." },
                    { img: logo28, text: "Easily integrate OpenCart to streamline order processing and shipping operations. Automatically sync orders and reduce manual effort in fulfillment." },
                    { img: logo29, text: "Advanced integration for Magento stores to handle high-volume orders efficiently. Enable automated shipping, bulk processing, and real-time order tracking." },
                    { img: logo30, text: "Connect PrestaShop to manage shipping and logistics without switching platforms. Automate order sync and improve delivery efficiency with smart courier selection." },
                    { img: logo31, text: "Enable seamless shipping integration for StoreHippo-powered D2C brands. Manage orders, automate dispatch, and track deliveries in real time." },
                    { img: logo32, text: "Integrate Ecwid stores to simplify shipping and fulfillment operations. Sync orders instantly and manage deliveries with multiple courier options." },
                    { img: logo33, text: "Link Razorpay to streamline payment reconciliation with shipping workflows. Track COD and prepaid orders with better financial visibility." },
                    { img: logo34, text: "Integrate Unicommerce to centralize order, inventory, and shipping management. Improve operational efficiency with automated logistics workflows." },
                    { img: logo35, text: "Enable PhonePe integration for smooth payment tracking and reconciliation. Get better visibility on transactions linked to shipments and deliveries." },
                ],
            },
            {
                title: "Marketplaces",
                items: [
                    { img: logo25, text: "Seamlessly sync and manage your Amazon orders with automated shipping and tracking. Process orders faster with real-time updates and centralized logistics management" },
                ],
            },
            {
                title: "Shopping carts",
                items: [
                    { img: logo27, text: "Connect your WooCommerce store to manage orders and shipments from a single dashboard. Automate shipping workflows and provide real-time tracking to customers." },
                    { img: logo28, text: "Easily integrate OpenCart to streamline order processing and shipping operations. Automatically sync orders and reduce manual effort in fulfillment." },
                    { img: logo29, text: "Advanced integration for Magento stores to handle high-volume orders efficiently. Enable automated shipping, bulk processing, and real-time order tracking." },
                    { img: logo34, text: "Integrate Unicommerce to centralize order, inventory, and shipping management. Improve operational efficiency with automated logistics workflows." },
                    { img: logo30, text: "Connect PrestaShop to manage shipping and logistics without switching platforms. Automate order sync and improve delivery efficiency with smart courier selection." },
                    { img: logo31, text: "Enable seamless shipping integration for StoreHippo-powered D2C brands. Manage orders, automate dispatch, and track deliveries in real time." },
                    { img: logo32, text: "Integrate Ecwid stores to simplify shipping and fulfillment operations. Sync orders instantly and manage deliveries with multiple courier options." },
                    { img: logo26, text: "Integrate your Shopify store to automate order imports, shipping, and tracking updates. Simplify fulfillment with real-time sync and multi-courier shipping options." },
                ],
            },
            {
                title: "Payment Partners",
                items: [
                    { img: logo33, text: "Link Razorpay to streamline payment reconciliation with shipping workflows. Track COD and prepaid orders with better financial visibility." },
                    { img: logo35, text: "Enable PhonePe integration for smooth payment tracking and reconciliation. Get better visibility on transactions linked to shipments and deliveries." }
                ],
            },
        ];
    return (
        <div>
            <Helmet>
                <title>ParcelX - Channel Integration</title>
            </Helmet>
            <section className="section01">
                <div className="container-fluid">
                    <div className='col-md-11 mx-auto'>
                        <div className='row '>
                            <div className='col-md-8'>
                                <h3 className='pt-5'>Our Trusted Courier Partner Network</h3>
                                <p>ParcelX seamlessly connects your online store, marketplaces, and tools into one unified platform. Sync orders in real time, automate shipping, and manage your entire logistics workflow effortlessly—all from a single dashboard.</p>
                                <p>Simplify operations, reduce manual work, and deliver faster while keeping everything perfectly in sync across every channel you sell on. Gain full visibility into your operations with real-time insights and analytics, helping you make smarter decisions and scale with confidence. Built for speed and flexibility, ParcelX grows with your business at every stage.</p>
                                <SecondaryBtn text={'Get Started'} href='https://seller.parcelx.in/register' />
                            </div>
                            <div className='col-md-4 text-md-end position-relative'>
                                <img className='img-fluid right-image courier-img' src={pxImg01} />
                            </div>
                        </div>
                    </div>     
                </div>
            </section>
            <section className='section02'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <Tabs tabsData={tabsData}/>
                    </div>
                </div>
            </section>
            <MainTestimonial />
            {/* <Blog /> */}
            <Cta />
        </div>
    )
}
